import React from 'react'

import DefaultCarousel from 'src/components/DefaultCarousel'
import ScrollTo from 'src/components/ScrollTo/ScrollTo'
import { sanitizeHtml } from 'src/utils/htmlSanitizer'

import { Section, ExpertCard, Button } from './style'

const experts = [
  {
    src: 'https://central-imagens.bancointer.com.br/cffb33a9/image-daniela-barreto.webp',
    alt: 'Daniela Barreto, Head de Estratégias de Investimentos',
    titleExpert: '<span class="d-block">Daniela</span> Barreto',
    description: '<span class="d-block">Head de Estratégias</span> de Investimentos',
  },
  {
    src: 'https://central-imagens.bancointer.com.br/cffb33a9/image-rafael-winalda.webp',
    alt: 'Rafael Winalda, Especialista em Renda Fixa',
    titleExpert: '<span class="d-block">Rafael</span> Winalda',
    description: '<span class="d-block">Especialista em</span> Renda Fixa',
  },
  {
    src: 'https://central-imagens.bancointer.com.br/cffb33a9/image-bernardo-pascowitch.webp',
    alt: 'Bernardo Pascowitch, Especialista em Criptomoedas',
    titleExpert: '<span class="d-block">Bernardo</span> Pascowitch',
    description: '<span class="d-block">Especialista em</span> criptomoedas',
  },
  {
    src: 'https://central-imagens.bancointer.com.br/cffb33a9/image-leandro-martins.webp',
    alt: 'Leandro Martins, Especialista em Renda Variável',
    titleExpert: '<span class="d-block">Leandro</span> Martins',
    description: '<span class="d-block">Especialista em</span> Renda Variável',
  },
]

const OurTimeOfExperts = () => (
  <Section id="nosso-time-de-especialistas">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h2 className="fs-24 fs-md-28 fs-lg-40 fs-xl-50 text-white text-center">
            Nosso time <strong className="subtitle">de especialistas</strong>
          </h2>
          <p className="fs-16 text-white fw-400 mb-4 text-center">
            Gestão profissional para quem quer evoluir o patrimônio em qualquer cenário.
          </p>
        </div>
        <div className="col-12">
          <DefaultCarousel
            sm={{ items: 1, partialVisibilityGutter: 130.62 }}
            md={{ items: 3, partialVisibilityGutter: 35.9 }}
            lg={{ items: 3, partialVisibilityGutter: 50 }}
            xl={{ items: 5 }}
            itemClass="margin-card-experts"
            containerClass="carrossel"
            showDots={false}
          >
            {experts.map((expert) => (
              <ExpertCard key={expert.src}>
                <img src={expert.src} alt={expert.alt} loading="lazy" />
                <div>
                  <h3 dangerouslySetInnerHTML={{ __html: sanitizeHtml(expert.titleExpert) }} />
                  <p dangerouslySetInnerHTML={{ __html: sanitizeHtml(expert.description) }} />
                </div>
              </ExpertCard>
            ))}
          </DefaultCarousel>
          <div className="col-12 d-flex align-items-center justify-content-center">
            <ScrollTo to="#hero-modal-form" title="Quero receber">
              <Button>Quero receber</Button>
            </ScrollTo>
          </div>
        </div>
      </div>
    </div>
  </Section>
)

export default OurTimeOfExperts
